var _defs, _path, _path2, _text, _text2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _rect, _g8, _g9, _text3, _text4, _text5, _path3, _g10, _text6, _text7, _text8, _g11, _path4, _path5, _g12, _path6, _g13, _path7, _text9, _g14, _g15, _g16, _text10, _path8, _path9, _g17, _path10, _g18, _g19, _path11, _text11, _g20, _path12, _g21, _text12, _text13, _g22, _g23, _g24, _path13, _text14, _text15, _path14, _g25, _text16, _g26, _g27, _path15, _text17, _text18, _text19, _g28, _path16, _path17, _text20, _g29, _path18, _g30, _text21, _text22, _g31, _g32, _g33, _path19, _text23, _text24, _path20, _g34, _text25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResQSlider1 = function SvgResQSlider1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 920 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "resQ_Slider1_svg__a",
    x1: 1.033,
    x2: 0.032,
    y1: 0.5,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f58b3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed595b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "resQ_Slider1_svg__b",
    x1: 0.978,
    x2: 0.012,
    y1: 0.036,
    y2: 0.969,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d55a86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a9548f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "resQ_Slider1_svg__c",
    x1: 1,
    x2: 0,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#69578e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4669a6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "resQ_Slider1_svg__i",
    x1: 0.527,
    x2: 0.53,
    y2: 1.078,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#feda00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#fdada8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f05a5c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "resQ_Slider1_svg__j",
    x1: 0.979,
    x2: 0.012,
    y1: 0.049,
    y2: 0.947,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#13c2a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c5879"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "resQ_Slider1_svg__g"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h125.271v14.476H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "resQ_Slider1_svg__h"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h122.274v13.476H0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fdfdfd",
    d: "M0 80h919v399H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcfcfc",
    d: "M0 76h919v160H0z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 18,
    fontWeight: 500,
    transform: "translate(0 109)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Dashboard"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 18,
    fontWeight: 500,
    transform: "translate(-1 311)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Projects"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(801 283)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 43,
    fill: "url(#resQ_Slider1_svg__a)",
    rx: 10
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 15,
    fontWeight: 500,
    transform: "translate(14 27)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "New Project")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#ddd",
    transform: "translate(677 283)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 43,
    stroke: "none",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 42,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 9.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#b1b1b1",
    transform: "translate(693 297)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 3,
    rx: 1,
    transform: "translate(0 7)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 3,
    rx: 1,
    transform: "translate(0 13)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#ddd",
    transform: "translate(615 283)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 43,
    stroke: "none",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 42,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 9.5
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#f05a5c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M636.915 297H632a1 1 0 0 0-1 1v4.915a1 1 0 0 0 1 1h4.915a1 1 0 0 0 1-1V298a1 1 0 0 0-1-1M645.663 297h-4.915a1 1 0 0 0-1 1v4.915a1 1 0 0 0 1 1h4.915a1 1 0 0 0 1-1V298a1 1 0 0 0-1-1M636.915 305.748H632a1 1 0 0 0-1 1v4.915a1 1 0 0 0 1 1h4.915a1 1 0 0 0 1-1v-4.915a1 1 0 0 0-1-1M645.663 305.748h-4.915a1 1 0 0 0-1 1v4.915a1 1 0 0 0 1 1h4.915a1 1 0 0 0 1-1v-4.915a1 1 0 0 0-1-1"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#ddd",
    transform: "translate(739 283)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 43,
    stroke: "none",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 42,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 9.5
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#b1b1b1",
    stroke: "#b1b1b1",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M754.742 299.525h8.556a2.768 2.768 0 0 0 5.343 0h1.628a.742.742 0 0 0 0-1.483h-1.639a2.768 2.768 0 0 0-5.343 0h-8.545a.742.742 0 1 0 0 1.483Zm11.236-2.041a1.3 1.3 0 1 1-1.308 1.3 1.3 1.3 0 0 1 1.308-1.3ZM770.269 304.167h-8.558a2.766 2.766 0 0 0-5.341 0h-1.628a.742.742 0 0 0 0 1.483h1.634a2.766 2.766 0 0 0 5.341 0h8.552a.742.742 0 0 0 0-1.483Zm-11.239 2.041a1.3 1.3 0 1 1 .923-.378 1.3 1.3 0 0 1-.923.378ZM770.269 310.294h-1.639a2.768 2.768 0 0 0-5.343 0h-8.545a.742.742 0 0 0 0 1.483h8.556a2.768 2.768 0 0 0 5.343 0h1.628a.742.742 0 1 0 0-1.483Zm-4.29 2.043a1.3 1.3 0 1 1 1.291-1.3 1.3 1.3 0 0 1-1.291 1.3Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 17,
    fill: "#d5d5d5",
    rx: 1,
    transform: "translate(81 296)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#resQ_Slider1_svg__b)",
    stroke: "#ebebeb",
    transform: "translate(309.499 130)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 134,
    stroke: "none",
    rx: 20
  }), /*#__PURE__*/React.createElement("rect", {
    width: 299,
    height: 133,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 19.5
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 15,
    transform: "translate(391.499 160)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ResQ Analysis")), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-ExtraBold, Poppins",
    fontSize: 25,
    fontWeight: 800,
    transform: "translate(391.499 191)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1,00,000")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 11,
    transform: "translate(322.499 221)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Inorganic"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Poppins-Bold, Poppins",
    fontSize: 13,
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 19
  }, "20,000")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 11,
    transform: "translate(399.499 221)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Least Organic"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Poppins-Bold, Poppins",
    fontSize: 13,
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 19
  }, "30,000")))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 11,
    transform: "translate(500.499 221)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Moderately "), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Poppins-Bold, Poppins",
    fontSize: 13,
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 19
  }, "10,000")))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m366.247 181.496-5.845 5.845-2.211-2.211 1.216-1.22-3.654-3.654a21.2 21.2 0 0 0 3.416-3.41l3.652 3.65 1.217-1.217Zm6.352 6.346-5.338-5.336-5.854 5.844 5.338 5.34a4.136 4.136 0 0 0 5.847-5.851Zm-38.356-18.172h2.789v-7.274h-2.789Zm13.953 0h2.787v-10.949h-2.787Zm-6.977 0h2.788v-14.552h-2.787Zm1.394 13.742a19.71 19.71 0 1 1 13.933-5.774 19.7 19.7 0 0 1-13.933 5.774m12.144-7.565a17.166 17.166 0 1 0-12.144 5.032 17.17 17.17 0 0 0 12.144-5.032m3.6-12.142a15.75 15.75 0 0 1-15.744 15.745 15.741 15.741 0 1 1 15.743-15.745Zm-3.791 6.68a.713.713 0 0 0-.712-.716h-1.441v-11.664a.716.716 0 0 0-.716-.716h-4.217a.72.72 0 0 0-.716.716v11.665h-1.328v-15.274a.716.716 0 0 0-.716-.716h-4.213a.72.72 0 0 0-.716.716v15.274h-1.327v-7.99a.716.716 0 0 0-.712-.716h-4.225a.715.715 0 0 0-.716.716v7.99h-1.437a.716.716 0 1 0 0 1.431c.718 0 1.439.01 2.159 0h20.319a.71.71 0 0 0 .5-.211.7.7 0 0 0 .207-.505Z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#resQ_Slider1_svg__c)",
    stroke: "#ebebeb",
    transform: "translate(619 130)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 134,
    stroke: "none",
    rx: 20
  }), /*#__PURE__*/React.createElement("rect", {
    width: 299,
    height: 133,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 19.5
  }))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 11,
    transform: "translate(632 225)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Total Responses"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Poppins-Bold, Poppins",
    fontSize: 13,
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 19
  }, "1,00,000")))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 11,
    transform: "translate(726 225)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Total Filtered Out"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Poppins-Bold, Poppins",
    fontSize: 13,
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 19
  }, "71,234")))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 11,
    transform: "translate(823 225)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Total Qualified"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Poppins-Bold, Poppins",
    fontSize: 13,
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 19
  }, "28,766")))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 15,
    transform: "translate(694 160)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ResQ Efficiency")), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-ExtraBold, Poppins",
    fontSize: 25,
    fontWeight: 800,
    transform: "translate(694 191)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1,00,000")), /*#__PURE__*/React.createElement("path", {
    d: "M657.039 172.768a.959.959 0 0 1-1.918 0 .959.959 0 0 1 1.918 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.08 158.384a14.4 14.4 0 0 0-14.384 14.384 14 14 0 0 0 .134 1.918h2.1a10 10 0 0 1 5.379 1.563l3.069 1.947a.75.75 0 0 0 .393.115h6.511a5.53 5.53 0 0 1 5.327 3.864l3.049-.892a14.375 14.375 0 0 0-11.584-22.9Zm8.132 7.6-5.543 5.547a3 3 0 0 1 .288 1.237 2.877 2.877 0 1 1-2.877-2.872 2.8 2.8 0 0 1 1.227.288l5.552-5.552a.955.955 0 0 1 1.352 0 .967.967 0 0 1 0 1.362Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.039 174.685h3.855a16 16 0 0 1-.115-1.918 16.3 16.3 0 0 1 32.6 0 16.04 16.04 0 0 1-1.956 7.709l.805-.23a5.4 5.4 0 0 1 1.5-.211 5.4 5.4 0 0 1 1.975.374 20.02 20.02 0 0 0-2.225-19.293l1.563-1.573a1.9 1.9 0 0 0 .566-1.352 1.94 1.94 0 0 0-.556-1.362l-2.042-2.033a1.964 1.964 0 0 0-2.7 0l-1.578 1.574a19.95 19.95 0 0 0-8.3-3.433v-2.225h.479a1.923 1.923 0 0 0 1.921-1.918v-2.876a1.923 1.923 0 0 0-1.916-1.918h-7.671a1.917 1.917 0 0 0-1.918 1.918v2.877a1.917 1.917 0 0 0 1.918 1.918h.479v2.225a19.9 19.9 0 0 0-8.292 3.432l-1.573-1.573a1.92 1.92 0 0 0-2.714 0l-2.035 2.033a1.91 1.91 0 0 0 0 2.714l1.573 1.573a20 20 0 0 0-3.74 11.651 18 18 0 0 0 .1 1.918ZM671.767 182.087l-6.962 2.023a5.6 5.6 0 0 1-.182 1.045c-.019.048-.029.1-.048.144a5.39 5.39 0 0 1-3.366 3.452 4.9 4.9 0 0 1-1.764.307h-6.492a.959.959 0 0 1 0-1.918h6.491a3.2 3.2 0 0 0 1.141-.2 3.48 3.48 0 0 0 2.167-2.225v-.01a3.5 3.5 0 0 0 .082-1.726 3.58 3.58 0 0 0-3.549-2.751h-6.514a2.65 2.65 0 0 1-1.419-.412l-3.068-1.948a8.13 8.13 0 0 0-4.358-1.266h-11.819v15.276h6.175a1.73 1.73 0 0 1 .873.24l6.635 3.864a12.59 12.59 0 0 0 11.727.508l16.7-7.92a3.477 3.477 0 0 0-2.455-6.482Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcfcfc",
    d: "M0 0h919v74H0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M0 75h919v1H0z"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#eaeaea",
    transform: "translate(662.238 13)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    stroke: "none",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 9.5
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "m695.426 35.128-.361-.874c1.237-2.853 1.156-2.938.914-3.182l-1.58-1.576-.157-.136h-.182c-.1 0-.384 0-2.788 1.112l-.885-.365c-1.143-2.892-1.26-2.892-1.599-2.892h-2.226c-.335 0-.465 0-1.523 2.9l-.88.365a15 15 0 0 0-2.833-1.059h-.212l-1.695 1.694c-.261.265-.352.352.957 3.161l-.361.872c-2.896 1.145-2.896 1.255-2.896 1.614v2.223c0 .35 0 .473 2.9 1.536l.361.87c-1.237 2.853-1.154 2.938-.914 3.182l1.581 1.578.157.138h.185c.1 0 .38 0 2.786-1.114l.883.367c1.144 2.887 1.26 2.887 1.606 2.887h2.221c.342 0 .462 0 1.525-2.9l.885-.365a15 15 0 0 0 2.828 1.061h.212l1.717-1.71c.244-.25.329-.337-.972-3.136l.359-.872c2.9-1.154 2.9-1.275 2.9-1.623V36.66c-.004-.345-.004-.473-2.913-1.532m-7.7 6.4a3.713 3.713 0 1 1 3.7-3.711 3.713 3.713 0 0 1-3.7 3.711"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#dedede",
    transform: "translate(281.581 13)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 247,
    height: 50,
    stroke: "none",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 49,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 9.5
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    fillRule: "evenodd",
    d: "M315.269 42.176a8.03 8.03 0 1 1 .988-.988l5.165 5.163a.7.7 0 0 1-.988.988Zm0-1.979a6.634 6.634 0 1 0-.987.987 6.7 6.7 0 0 0 .987-.987"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    fill: "#b1b1b1",
    fontFamily: "Poppins-Light, Poppins",
    fontSize: 12,
    fontWeight: 300,
    transform: "translate(385.581 43)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -50.61,
    y: 0
  }, "Search with data"))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(782 13)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 137,
    height: 50,
    fill: "#ebebeb",
    rx: 10
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Light, Poppins",
    fontSize: 14,
    fontWeight: 300,
    transform: "translate(53 22)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Richard ")), /*#__PURE__*/React.createElement("text", {
    fill: "#7e7e7e",
    fontFamily: "Poppins-Light, Poppins",
    fontSize: 12,
    fontWeight: 300,
    transform: "translate(53 38)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Director")), /*#__PURE__*/React.createElement("path", {
    d: "M123.888 28.076a.66.66 0 0 1-.45-.18l-6.085-5.776a.65.65 0 1 1 .893-.943l5.641 5.353 5.638-5.353a.65.65 0 1 1 .894.943l-6.082 5.776a.65.65 0 0 1-.45.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a2a2a2",
    fillRule: "evenodd",
    d: "M40.368 3.998a6.14 6.14 0 0 1 6.138 6.138v30.33a6.14 6.14 0 0 1-6.138 6.138H10.04a6.14 6.14 0 0 1-6.14-6.138V10.139a6.14 6.14 0 0 1 6.14-6.141Zm-10.595 20.94a14.97 14.97 0 0 1 9.744 10.124v.005a3.97 3.97 0 0 1-3.826 5.037c-5.281 0-15.7 0-20.983-.043a3.93 3.93 0 0 1-3.776-4.981 14.85 14.85 0 0 1 9.7-10.142 7.943 7.943 0 1 1 9.137 0ZM25.2 26.384a12.65 12.65 0 0 0-12.181 9.274 1.762 1.762 0 0 0 1.7 2.234h.009c5.278.043 15.689.043 20.967.043a1.806 1.806 0 0 0 1.741-2.288 12.744 12.744 0 0 0-12.228-9.265Zm0-2.167a5.777 5.777 0 1 0-5.777-5.777 5.78 5.78 0 0 0 5.777 5.777"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#eaeaea",
    transform: "translate(722.169 13)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    stroke: "none",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 9.5
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    fill: "#f05a5c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M756.972 44.604a1.42 1.42 0 0 1-1.412 1.415h-16.788a1.4 1.4 0 0 1-1.415-1.339 3.5 3.5 0 0 1 3.2-3.561v-4.412a6.6 6.6 0 0 1 6.52-6.627h.139a6.6 6.6 0 0 1 6.563 6.627v4.412a3.5 3.5 0 0 1 3.193 3.485M748.807 48.427h-3.279a.67.67 0 1 1 0-1.339h3.279a.67.67 0 1 1 0 1.339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.168 31.208a.67.67 0 0 1-.67-.661v-1.675a.67.67 0 0 1 1.339 0v1.674a.67.67 0 0 1-.669.662"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#resQ_Slider1_svg__g)",
    style: {
      isolation: "isolate"
    },
    transform: "translate(.472 55.524)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#resQ_Slider1_svg__h)",
    style: {
      isolation: "isolate"
    },
    transform: "translate(.999 1)"
  }, _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    fill: "#8b8c8f",
    fontFamily: "Poppins-Bold, Poppins",
    fontSize: 7,
    fontWeight: 700,
    letterSpacing: ".092em",
    transform: "translate(0 6.573)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Target Right, Gain Insight"))))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#393939",
    d: "M9.232 27.218a13.8 13.8 0 0 1 3.461-5.588 7.08 7.08 0 0 1 4.835-1.788 3 3 0 0 1 .467.028 3 3 0 0 0 .412.028 16 16 0 0 0-.247 1.76q-.082.935-.082 2.2v2.7a8 8 0 0 0 .055.935l-.495.44a6 6 0 0 0-1.236-.55 5.1 5.1 0 0 0-1.566-.22 4.93 4.93 0 0 0-3.9 1.623 5.6 5.6 0 0 0-1.429 3.823v2.2q0 3.355.082 6.326t.357 5.721a12 12 0 0 0-1.786-.11H3.517a13 13 0 0 0-1.813.11q.275-2.75.357-5.721t.082-6.326v-2.2q0-3.355-.082-6.3t-.357-5.912q.934.11 1.9.193t1.9.083 1.9-.083 1.9-.193l-.165 6.711Zm20.5 6.491a18.5 18.5 0 0 0 .432 4.121 10.3 10.3 0 0 0 1.346 3.328 6.6 6.6 0 0 0 2.308 2.2 6.5 6.5 0 0 0 3.269.8 10.26 10.26 0 0 0 6.758-2.475l.659.5-1.205 3.077a11.2 11.2 0 0 1-3.3 1.678 16.6 16.6 0 0 1-5.055.633 17.3 17.3 0 0 1-5.11-.743 10.9 10.9 0 0 1-4.256-2.448 12 12 0 0 1-2.914-4.318 16.4 16.4 0 0 1-1.071-6.243 18.2 18.2 0 0 1 .962-6.216 12.3 12.3 0 0 1 2.665-4.4 10.9 10.9 0 0 1 4.039-2.64 14.3 14.3 0 0 1 5.083-.88q5.44 0 8.324 3.19t2.885 9.021v1.155a2.5 2.5 0 0 1-.055.66Zm8.457-2.479a21.3 21.3 0 0 0-1.017-6.6q-.907-2.475-3.05-2.475a2.76 2.76 0 0 0-2.033.825 6 6 0 0 0-1.319 2.118 14 14 0 0 0-.742 2.915 28 28 0 0 0-.3 3.218Zm12.857 8.856a8.5 8.5 0 0 0 .852 1.678 6.4 6.4 0 0 0 1.291 1.43 6.1 6.1 0 0 0 1.841 1.018 7.4 7.4 0 0 0 2.5.385 4.14 4.14 0 0 0 2.967-.99 2.93 2.93 0 0 0 1.044-2.145 2.5 2.5 0 0 0-.934-2.035 10.4 10.4 0 0 0-2.335-1.4q-1.4-.633-3.05-1.293a14 14 0 0 1-3.05-1.678 8.7 8.7 0 0 1-2.335-2.558 7.55 7.55 0 0 1-.934-3.96 8.7 8.7 0 0 1 .852-3.988 8.05 8.05 0 0 1 2.225-2.75 9.4 9.4 0 0 1 3.1-1.6 11.8 11.8 0 0 1 3.434-.523 11.8 11.8 0 0 1 4.094.66 17.2 17.2 0 0 1 3.656 1.93 15 15 0 0 0-.822 2.363 21 21 0 0 0-.495 2.475h-1.538a7.7 7.7 0 0 0-.545-1.455 6.2 6.2 0 0 0-1.044-1.513 5.5 5.5 0 0 0-1.593-1.183 5 5 0 0 0-2.253-.468 4.37 4.37 0 0 0-2.775.88 2.79 2.79 0 0 0-1.126 2.31 2.61 2.61 0 0 0 .962 2.118 9.6 9.6 0 0 0 2.39 1.4q1.429.605 3.132 1.21a14 14 0 0 1 3.132 1.568 8.2 8.2 0 0 1 2.39 2.5 7.37 7.37 0 0 1 .962 3.96 9.1 9.1 0 0 1-.879 4.153 8.2 8.2 0 0 1-2.363 2.86 9.5 9.5 0 0 1-3.385 1.63 15.7 15.7 0 0 1-3.984.5 13 13 0 0 1-4.451-.715 14.8 14.8 0 0 1-3.131-1.49 29.3 29.3 0 0 0 .824-5.281Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#resQ_Slider1_svg__i)",
    d: "M108.812 20.656c-.551-3.812 3.176-7.239 7.9-4.152 4.584 7.835 2.717 13.468 0 21.278 3.756 3.784 3.529 3.125 6.2 6.346.6 3.67-.843 7.224-6.731 5.646-3.9-4.138-.906-.906-4.99-5.183-11.876 7.527-31.6 7.639-36.82-12.747C73.549 22 75.269 7.75 95.754 4.679c9.155-.9 7.839 9.2 1.959 8.965-2.29-.214-14.539 2.436-14.524 11.956s7.683 16.088 14.523 15.088 15.271-6.32 11.1-20.032",
    transform: "translate(0 1)"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#ebebeb",
    transform: "translate(602.307 13)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    stroke: "none",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 9.5
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M625.617 38.357a6.7 6.7 0 0 0-1.586 1.166c-.464.414-2.5 2.644-3.2 3.482-1.007 1.214-.959 1.14-1.068-.339-.028-.383-.1-.761-.145-1.142-.064-.5-.243-.933-.763-1-.848-.109-1.548.082-1.548.8 0 1.869.209 3.619.37 5.514.028.332.013.75.281.986.335.287 1.211.188 1.742.163a29 29 0 0 0 4.708-.494c.745-.205.74-.812.7-1.42-.018-.271-.191-.806-.636-.827-.679-.032-1.4-.008-1.953 0-.445.006-.591-.042.181-.819 1.1-1.105 2.277-2.173 3.27-3.374a3.16 3.16 0 0 0 .817-1.271c.115-.654-.377-1.725-1.17-1.425m12.214-11.108c-.216-.265-.657-.36-2.81-.076a25.5 25.5 0 0 1-3.837.249c-.642-.013-.9.776-.938 1.289a.77.77 0 0 0 .241.677 2.7 2.7 0 0 0 1.262.274c.453.046.908.063 1.361.1-.558.626-1.306 1.527-1.566 1.818-.8.888-1.36 1.565-2.133 2.473-.387.454-1.011 1.057-.752 1.712a1.143 1.143 0 0 0 1.476.558 13 13 0 0 0 2.056-1.7c.64-.619 1.092-1.191 1.7-1.844.317-.342.678-.806 1.05-1.159l.125 1.532c.1 1.174.842 1.2 1.579 1.177.546-.014.787-.385.914-1 .107-.516.168-2.744.307-4.219.041-.496.201-1.568-.035-1.861M629.646 38.357a6.7 6.7 0 0 1 1.59 1.166c.464.414 2.5 2.644 3.2 3.482 1.007 1.214.959 1.14 1.068-.339.028-.383.1-.761.145-1.142.064-.5.243-.933.763-1 .848-.109 1.548.082 1.548.8 0 1.869-.209 3.619-.37 5.514-.028.332-.013.75-.281.986-.335.287-1.211.188-1.742.163a29 29 0 0 1-4.708-.494c-.745-.205-.74-.812-.7-1.42.018-.271.191-.806.636-.827.679-.032 1.4-.008 1.953 0 .445.006.591-.042-.181-.819-1.1-1.105-2.277-2.173-3.27-3.374a3.16 3.16 0 0 1-.817-1.271c-.119-.654.373-1.725 1.166-1.425m-12.215-11.108c.216-.265.657-.36 2.81-.076a25.5 25.5 0 0 0 3.837.249c.642-.013.9.776.938 1.289a.77.77 0 0 1-.241.677 2.7 2.7 0 0 1-1.262.274c-.453.046-.908.063-1.361.1.558.626 1.306 1.527 1.566 1.818.8.888 1.36 1.565 2.133 2.473.387.454 1.011 1.057.752 1.712a1.143 1.143 0 0 1-1.476.558 13 13 0 0 1-2.056-1.7c-.64-.619-1.092-1.191-1.7-1.844-.317-.342-.678-.806-1.05-1.159l-.125 1.532c-.1 1.174-.842 1.2-1.579 1.177-.546-.014-.787-.385-.914-1-.107-.516-.168-2.744-.307-4.219-.04-.496-.2-1.568.035-1.861"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    fontSize: 15
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#ee5b5a",
    fontFamily: "Poppins-Bold, Poppins",
    fontWeight: 700,
    transform: "translate(93 310)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "In Progress"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, "(09)")), /*#__PURE__*/React.createElement("text", {
    fill: "#9d9999",
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500,
    transform: "translate(228 310)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fill: "#000"
  }, "Live"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "(04)")), /*#__PURE__*/React.createElement("text", {
    fill: "#9d9999",
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500,
    transform: "translate(306 310)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fill: "#000"
  }, "Paused"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "(02)")), /*#__PURE__*/React.createElement("text", {
    fill: "#9d9999",
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500,
    transform: "translate(410 310)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fill: "#000"
  }, "Drafts"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "(03)")), /*#__PURE__*/React.createElement("text", {
    fill: "#9d9999",
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500,
    transform: "translate(503 310)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fill: "#000"
  }, "Closed"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "(01)")))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#e5e5e5",
    transform: "translate(-1 347)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 450,
    height: 133,
    stroke: "none",
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 449,
    height: 132,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 4.5
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#989898",
    d: "M316.945 438.869a10.2 10.2 0 0 1 .248 2.236 10.06 10.06 0 0 1-3.076 7.254 27 27 0 0 1-.629-2.154 21 21 0 0 1-.446-2.407c-.162-1.311-.5-1.71-.924-1.658-.37.046-.663.475-.955.913a2.4 2.4 0 0 1-.53.656c-.326.122-1.332-.436-2.112-1.142a3.8 3.8 0 0 1-.642-.728 1.2 1.2 0 0 1-.236-.619.62.62 0 0 1 .4-.545 2 2 0 0 1 .206-.076 1.45 1.45 0 0 0 1.217-1.569c0-.478.353-.814.863-1.069a8.8 8.8 0 0 1 1.809-.585l.008.015a26 26 0 0 0 1.8 2.476l.4.507a.9.9 0 0 0 .316.259l.032.015h.012v-.017h.3630000000000001a.9.9 0 0 0 .713-.349l.008-.011.006-.008.006-.008.006-.008.008-.008.006-.008.006-.008.006-.008.006-.008.006-.008.006-.008.006-.008.006-.008.006-.008.006-.008.006-.008.006-.008.006-.008.006-.006.006-.008.006-.008.006-.008.006-.008.006-.008.006-.008.006-.008.006-.006.006-.006.006-.006.006-.008.006-.008.006-.006.006-.006.006-.008.006-.006.006-.006.006-.006.006-.006.006-.008.006-.006.006-.006.006-.006.003.061.008-.013.006-.006.006-.008.006-.006.006-.006.006-.008.006-.006.006-.006.006-.008.006-.006.006-.006.006-.006.006-.008.006-.006.006-.006.006-.006.011-.015v-.006l.006-.006.006-.008.013-.015.011-.017.006-.006.006-.008.013-.015.011-.017.013-.015.008-.021.006-.006.006-.008.013-.017.011-.015.013-.017.013-.017.006-.006.006-.008.013-.017.011-.015.013-.017.013-.015.006-.008.006-.008.013-.017.011-.015q.28-.351.542-.695m-4.117 7.5a22 22 0 0 1-.461-2.485 6.7 6.7 0 0 0-.162-1.062 2.7 2.7 0 0 0-.473.616 2.3 2.3 0 0 1-.856.913c-.532.2-1.868-.425-2.807-1.275a4.6 4.6 0 0 1-.757-.861 1.9 1.9 0 0 1-.345-.978 1.25 1.25 0 0 1 .751-1.155 2 2 0 0 1 .318-.126.876.876 0 0 0 .753-.913 1.87 1.87 0 0 1 1.239-1.681 9 9 0 0 1 1.816-.606 4 4 0 0 1-.224-1.726 3.8 3.8 0 0 1 .932-2.2q.065-.072.135-.141a10.1 10.1 0 0 0-2.979-1.347.3.3 0 0 1-.061.126 18 18 0 0 1-2.327 2.614 11.5 11.5 0 0 1-3.146 1.936 6.4 6.4 0 0 0-1.418.827 4 4 0 0 0-.25.212 3.38 3.38 0 0 1 2.218.844 3 3 0 0 1 .25.248 3.82 3.82 0 0 1 .932 2.207 3.93 3.93 0 0 1-.528 2.359c-.149.25-.326.513-.515.783a3.35 3.35 0 0 1 1.22.57 1.52 1.52 0 0 1 .614 1.178 2.36 2.36 0 0 1-.417 1.3 7.8 7.8 0 0 1-2.377 2.2l-.025.015a2.1 2.1 0 0 0-.663.568 4.5 4.5 0 0 0-.518.858v.008a10.1 10.1 0 0 0 10.9-1.355.3.3 0 0 1-.065-.114 25 25 0 0 1-.704-2.361Zm-13.606-4.359a4 4 0 0 1-.2-1.652q.012-.15.038-.3a6 6 0 0 1-.8-.025 6.5 6.5 0 0 1-1.172-.231 10 10 0 0 0-.084 1.3 10.1 10.1 0 0 0 .646 3.56q.324-.672.692-1.307a15 15 0 0 1 .88-1.345m-.9-2.655a5 5 0 0 0 .915.008 3.6 3.6 0 0 1 .246-.545 3.6 3.6 0 0 1 .417-.606l.05-.059.008-.008a3.24 3.24 0 0 1 1.414-.884 5.5 5.5 0 0 1 .915-.907 7 7 0 0 1 1.57-.915 10.8 10.8 0 0 0 2.964-1.824 16.7 16.7 0 0 0 2.138-2.386 10.1 10.1 0 0 0-11.759 7.89.2.2 0 0 1 .04.011 5.2 5.2 0 0 0 1.083.225Zm5.226 8.8a7.1 7.1 0 0 0 2.152-1.975 1.7 1.7 0 0 0 .313-.913.86.86 0 0 0-.36-.665 3 3 0 0 0-1.231-.509c-.221.295-.452.591-.68.882l-.015.017v.006l-.008.011-.015.017-.008.011v.006l-.013.017-.015.017-.013.017-.015.017v.006l-.008.011-.013.017-.008.011v.006l-.013.017-.013.017-.006.006-.006.006-.006.006-.006.006-.006.006-.006.006-.006.008-.006.006v.006l-.006.006-.031.011v.006l-.006.006-.011.013-.006.006-.006.006-.006.006-.006.006-.011.015-.006.006-.006.008-.006.006-.006.008-.006.006-.006.008-.006.006-.006.006-.006.008-.006.006-.006.008-.006.008-.006.006-.006.008-.006.008-.006.008-.006.006-.006.006-.006.006-.006.006-.028.029-.006.006.013.013-.007.011-.006.008-.006.008-.006.008-.006.008-.006.008-.006.008-.006.008-.006.008-.006.008-.006.008-.01.02-.006.008-.006.008-.006.008-.006.008-.006.008-.006.008-.008.008-.006.008a.9.9 0 0 1-.711.347.9.9 0 0 1-.713-.347c-.158-.2-.276-.353-.4-.507a26 26 0 0 1-1.8-2.476q-.33.477-.623.98-.437.751-.8 1.538a.34.34 0 0 1-.168.166 10.15 10.15 0 0 0 4.13 4.471 5.2 5.2 0 0 1 .589-.972 2.75 2.75 0 0 1 .866-.734Zm-1.086-6.558a1.121 1.121 0 1 0-.8-.328 1.12 1.12 0 0 0 .8.328m-1.8-3.185a2.76 2.76 0 0 1 3.608 0 3 3 0 0 1 .2.2 3.13 3.13 0 0 1 .76 1.811 3.25 3.25 0 0 1-.433 1.95 26 26 0 0 1-1.755 2.4c-.149.191-.3.379-.4.509a.3.3 0 0 1-.076.065.2.2 0 0 1-.1.019.2.2 0 0 1-.1-.019.2.2 0 0 1-.076-.065c-.1-.13-.248-.318-.4-.509a26 26 0 0 1-1.755-2.4 3.25 3.25 0 0 1-.435-1.96 3.1 3.1 0 0 1 .76-1.807 3 3 0 0 1 .199-.194Zm.524.785a1.8 1.8 0 1 0 1.277-.53 1.8 1.8 0 0 0-1.28.53Zm16.2-2.148a26 26 0 0 1-1.755 2.4c-.149.191-.3.379-.4.509a.2.2 0 0 1-.076.065.2.2 0 0 1-.1.019.2.2 0 0 1-.1-.019.24.24 0 0 1-.076-.065c-.1-.128-.248-.318-.4-.509a26 26 0 0 1-1.755-2.4 3.26 3.26 0 0 1-.433-1.955 3.1 3.1 0 0 1 .76-1.807q.095-.1.2-.2a2.76 2.76 0 0 1 3.608 0 3 3 0 0 1 .2.2 3.14 3.14 0 0 1 .76 1.811 3.23 3.23 0 0 1-.436 1.951Zm-.52-1.9a1.81 1.81 0 1 0-.53 1.277 1.8 1.8 0 0 0 .527-1.273Zm-1.81-1.119a1.121 1.121 0 1 0 .8.328 1.13 1.13 0 0 0-.8-.328M352.784 438.241a1.537 1.537 0 0 0-1.537 1.538v6.8h7v-6.8a1.54 1.54 0 0 0-1.538-1.538zm2.043 10.032a.513.513 0 1 1-.513.513.513.513 0 0 1 .513-.513M354.653 431H336.54a1.54 1.54 0 0 0-1.539 1.539v10.338h14.521a.513.513 0 0 1 0 1.026H335v1.8a1.54 1.54 0 0 0 1.539 1.541h7.215v1.634h-2.051a.513.513 0 0 0 0 1.026h7.781a.513.513 0 0 0 0-1.026h-2.05v-1.634h3.1v-7.464a2.247 2.247 0 0 1 2.177-2.246.4.4 0 0 1 .07-.005h3.407v-4.989a1.54 1.54 0 0 0-1.539-1.539Zm-3.409 16.61v.754a1.54 1.54 0 0 0 1.54 1.538h3.921a1.54 1.54 0 0 0 1.538-1.538v-.754z"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    fill: "#ed5b5a",
    fontFamily: "HonestJohns, Honest Johns",
    fontSize: 21,
    transform: "translate(376 445.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Q"))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    fill: "#989898"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M429.774 449.73h-.876c-.478.516-.917.959-1.263 1.3a1.27 1.27 0 0 1-.886.36 1.25 1.25 0 0 1-.886-.363 35 35 0 0 1-1.263-1.294h-.879c-1.222.218-2.011.568-2.011.962 0 .668 2.256 1.211 5.039 1.211s5.039-.54 5.039-1.211c.004-.397-.785-.747-2.014-.965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.352 450.53a.57.57 0 0 0 .806 0c1.291-1.26 5.233-5.312 5.233-7.918a5.636 5.636 0 0 0-11.272 0c-.003 2.605 3.942 6.661 5.233 7.918m-2.623-8.164a3.027 3.027 0 1 1 3.028 3.028 3.03 3.03 0 0 1-3.029-3.028ZM418.831 431.782a.412.412 0 1 0 .412.412.413.413 0 0 0-.412-.412M421.697 431.782a.412.412 0 1 0 .412.412.413.413 0 0 0-.412-.412M434.186 431.917h-7.416a.277.277 0 1 0 0 .554h7.417a.277.277 0 1 0 0-.554Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.388 430h-15.27a3.12 3.12 0 0 0-3.118 3.118v.928h21.5v-.928a3.11 3.11 0 0 0-3.112-3.118m-15.557 3.295a1.1 1.1 0 1 1 1.1-1.1 1.1 1.1 0 0 1-1.1 1.1m2.866 0a1.1 1.1 0 1 1 1.1-1.1 1.1 1.1 0 0 1-1.1 1.1m12.49-.135h-7.417a.968.968 0 0 1 0-1.935h7.417a.968.968 0 0 1 0 1.935M416 443.286a3.12 3.12 0 0 0 3.115 3.122h2.807a7.54 7.54 0 0 1-1.5-3.793 6.325 6.325 0 0 1 12.649 0 7.53 7.53 0 0 1-1.5 3.793h2.81a3.12 3.12 0 0 0 3.115-3.122v-8.552H416Zm17.931-7.347a.347.347 0 0 1 .346-.346h.893a1.05 1.05 0 0 1 0 2.1h-.55v.81a.346.346 0 0 1-.692 0v-2.565Zm-1.4 0a.346.346 0 1 1 .692 0v2.561a.346.346 0 1 1-.692 0Zm-14.968-.46h3.237a.346.346 0 1 1 0 .692h-3.236a.346.346 0 1 1 0-.692Zm0 1.156h2.029a.346.346 0 0 1 0 .692h-2.028a.346.346 0 0 1 0-.692Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.529 436.641a.36.36 0 0 0-.36-.36h-.55v.72h.55a.36.36 0 0 0 .36-.36"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M0 428h89a19 19 0 0 1 19 19 19 19 0 0 1-19 19H0z"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.999 451)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "#4baf4b",
    rx: 5,
    transform: "translate(0 2)"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "ChickenSans-Regular, Chicken Sans",
    fontSize: 10,
    transform: "translate(22 11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.33,
    y: 0
  }, "600")))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    fill: "#333",
    fontFamily: "ChickenSans-Bold, Chicken Sans",
    fontSize: 13,
    fontWeight: 700,
    transform: "translate(82.999 444)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -14.742,
    y: 0
  }, "1000"))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    fill: "#333",
    fontFamily: "ChickenSans-Regular, Chicken Sans",
    fontSize: 11,
    transform: "translate(36.999 443)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -26.185,
    y: 0
  }, "Responses"))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.999 450)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "ChickenSans-Regular, Chicken Sans",
    fontSize: 10,
    transform: "translate(22 11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.26,
    y: 0
  }, "400")), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "#e66564",
    rx: 5,
    transform: "translate(0 3)"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#ddd",
    transform: "translate(393 356)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    stroke: "none",
    rx: 11
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 10.5
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    fill: "#989898"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.944 362.747a2.337 2.337 0 1 0 2.251 2.335 2.235 2.235 0 0 0-2.251-2.335M398 371.765a2.9 2.9 0 0 0 .6 1.7c.341.4 6.551.369 6.68 0a2.92 2.92 0 0 0 .6-1.7 3.886 3.886 0 0 0-3.926-3.809h-.036a3.886 3.886 0 0 0-3.918 3.809M406.413 360a2.235 2.235 0 0 0-2.252 2.335 2.253 2.253 0 1 0 4.5 0 2.234 2.234 0 0 0-2.248-2.335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.431 365.208h-.036a4.1 4.1 0 0 0-1.624.351 2.86 2.86 0 0 1-1.308 2.047 4.49 4.49 0 0 1 2.965 3.4 10.3 10.3 0 0 0 3.325-.288 2.9 2.9 0 0 0 .6-1.7 3.886 3.886 0 0 0-3.922-3.81"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#989898",
    d: "M437.744 366.766a1.561 1.561 0 1 1-1.561-1.561 1.56 1.56 0 0 1 1.561 1.561m-1.562-8.091a1.561 1.561 0 1 0 1.561 1.561 1.56 1.56 0 0 0-1.561-1.561m0 13.058a1.561 1.561 0 1 0 1.561 1.561 1.56 1.56 0 0 0-1.561-1.561"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 15,
    fontWeight: 500,
    transform: "translate(9 372)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "McDonalds Survey"))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    fill: "#6c6c6c",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 15,
    transform: "translate(9 395)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ASDF1234"))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#989898",
    d: "M90.474 384a6.016 6.016 0 1 0 6.016 6.016A6.017 6.017 0 0 0 90.474 384m-.7 8.613v-2.754a.7.7 0 0 1 1.39 0v2.754a.7.7 0 1 1-1.39 0m.7-4.208a.836.836 0 1 1 .836-.836.836.836 0 0 1-.836.836"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    fill: "#e4f4e4",
    stroke: "#4baf4b",
    transform: "translate(155 361)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 14,
    stroke: "none",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 13,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 1.5
  }))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    fill: "#4baf4b",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 10,
    fontWeight: 500,
    transform: "translate(160 372)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Live"))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#resQ_Slider1_svg__j)",
    stroke: "#ebebeb",
    transform: "translate(0 130)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 134,
    stroke: "none",
    rx: 20
  }), /*#__PURE__*/React.createElement("rect", {
    width: 299,
    height: 133,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 19.5
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 15,
    transform: "translate(92.922 159)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "All Projects")), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-ExtraBold, Poppins",
    fontSize: 25,
    fontWeight: 800,
    transform: "translate(92.922 190)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "300")))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M36.023 190.504H20.208A1.213 1.213 0 0 1 19 189.296v-33.247h8.394a.856.856 0 0 0 .856-.856v-6.62h23.258a1.213 1.213 0 0 1 1.208 1.208v19.517a13.761 13.761 0 0 0-16.693 21.206m28.108-12.306a3.386 3.386 0 0 0-3.275 2.572H46.487a.8.8 0 0 1-.25-1.558 2.371 2.371 0 1 0 2.483 3.157h1.772a4.084 4.084 0 1 1-1.118-3.684 4 4 0 0 1 .419.49h2.937a6.691 6.691 0 1 0 .4 3.2h1.722a8.384 8.384 0 1 1-.31-3.2h3.874a12.17 12.17 0 1 0 .21 3.2h2.231a3.385 3.385 0 0 0 3.275 2.573h11.5l-2.8-3.54 2.8-3.2Zm-17.426-18.293H25.011a.857.857 0 0 0 0 1.713h21.694a.857.857 0 0 0 0-1.713m0 5.569H25.011a.857.857 0 0 0 0 1.713h21.694a.857.857 0 0 0 0-1.713m-13.51 5.571h-8.184a.856.856 0 1 0 0 1.712h8.183a.856.856 0 0 0 0-1.712Zm-2.7 5.57h-5.484a.857.857 0 0 0 0 1.713h5.486a.857.857 0 0 0 0-1.713Zm0 5.569h-5.484a.857.857 0 0 0 0 1.713h5.486a.857.857 0 0 0 0-1.713Zm-10.433-27.847h6.474v-5.09Z"
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 11,
    transform: "translate(19 224)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "In Progress"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Poppins-Bold, Poppins",
    fontSize: 13,
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 19
  }, "130")))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 11,
    transform: "translate(117 224)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Drafts"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Poppins-Bold, Poppins",
    fontSize: 13,
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 19
  }, "70")))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 11,
    transform: "translate(187 224)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Closed"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Poppins-Bold, Poppins",
    fontSize: 13,
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 19
  }, "100")))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#e5e5e5",
    transform: "translate(469 347)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 450,
    height: 133,
    stroke: "none",
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 449,
    height: 132,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 4.5
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#989898",
    d: "M786.945 438.869a10.2 10.2 0 0 1 .248 2.236 10.06 10.06 0 0 1-3.076 7.254 27 27 0 0 1-.629-2.154 21 21 0 0 1-.446-2.407c-.162-1.311-.5-1.71-.924-1.658-.37.046-.663.475-.955.913a2.4 2.4 0 0 1-.53.656c-.326.122-1.332-.436-2.112-1.142a3.8 3.8 0 0 1-.642-.728 1.2 1.2 0 0 1-.236-.619.62.62 0 0 1 .4-.545 2 2 0 0 1 .206-.076 1.45 1.45 0 0 0 1.217-1.569c0-.478.353-.814.863-1.069a8.8 8.8 0 0 1 1.809-.585l.008.015a26 26 0 0 0 1.8 2.476l.4.507a.9.9 0 0 0 .316.259l.032.015h.012v-.017h.363a.9.9 0 0 0 .713-.349l.008-.011.006-.008.006-.008.006-.008.008-.008.006-.008.006-.008.006-.008.006-.008.006-.008.006-.008.006-.008.006-.008.006-.008.006-.008.006-.008.006-.008.006-.008.006-.006.006-.008.006-.008.006-.008.006-.008.006-.008.006-.008.006-.008.006-.006.006-.006.006-.006.006-.008.006-.008.006-.006.006-.006.006-.008.006-.006.006-.006.006-.006.006-.006.006-.008.006-.006.006-.006.006-.006.003.061.008-.013.006-.006.006-.008.006-.006.006-.006.006-.008.006-.006.006-.006.006-.008.006-.006.006-.006.006-.006.006-.008.006-.006.006-.006.006-.006.011-.015v-.006l.006-.006.006-.008.013-.015.011-.017.006-.006.006-.008.013-.015.011-.017.013-.015.008-.021.006-.006.006-.008.013-.017.011-.015.013-.017.013-.017.006-.006.006-.008.013-.017.011-.015.013-.017.013-.015.006-.008.006-.008.013-.017.011-.015q.28-.351.542-.695m-4.117 7.5a22 22 0 0 1-.461-2.485 6.7 6.7 0 0 0-.162-1.062 2.7 2.7 0 0 0-.473.616 2.3 2.3 0 0 1-.856.913c-.532.2-1.868-.425-2.807-1.275a4.6 4.6 0 0 1-.757-.861 1.9 1.9 0 0 1-.345-.978 1.25 1.25 0 0 1 .751-1.155 2 2 0 0 1 .318-.126.876.876 0 0 0 .753-.913 1.87 1.87 0 0 1 1.239-1.681 9 9 0 0 1 1.816-.606 4 4 0 0 1-.224-1.726 3.8 3.8 0 0 1 .932-2.2q.065-.072.135-.141a10.1 10.1 0 0 0-2.979-1.347.3.3 0 0 1-.061.126 18 18 0 0 1-2.327 2.614 11.5 11.5 0 0 1-3.146 1.936 6.4 6.4 0 0 0-1.418.827 4 4 0 0 0-.25.212 3.38 3.38 0 0 1 2.218.844 3 3 0 0 1 .25.248 3.82 3.82 0 0 1 .932 2.207 3.93 3.93 0 0 1-.528 2.359c-.149.25-.326.513-.515.783a3.35 3.35 0 0 1 1.22.57 1.52 1.52 0 0 1 .614 1.178 2.36 2.36 0 0 1-.417 1.3 7.8 7.8 0 0 1-2.377 2.2l-.025.015a2.1 2.1 0 0 0-.663.568 4.5 4.5 0 0 0-.518.858v.008a10.1 10.1 0 0 0 10.9-1.355.3.3 0 0 1-.065-.114 25 25 0 0 1-.704-2.361Zm-13.606-4.359a4 4 0 0 1-.2-1.652q.012-.15.038-.3a6 6 0 0 1-.8-.025 6.5 6.5 0 0 1-1.172-.231 10 10 0 0 0-.084 1.3 10.1 10.1 0 0 0 .646 3.56q.324-.672.692-1.307a15 15 0 0 1 .88-1.345m-.9-2.655a5 5 0 0 0 .915.008 3.6 3.6 0 0 1 .246-.545 3.6 3.6 0 0 1 .417-.606l.05-.059.008-.008a3.24 3.24 0 0 1 1.414-.884 5.5 5.5 0 0 1 .915-.907 7 7 0 0 1 1.57-.915 10.8 10.8 0 0 0 2.964-1.824 16.7 16.7 0 0 0 2.138-2.386 10.1 10.1 0 0 0-11.759 7.89.2.2 0 0 1 .04.011 5.2 5.2 0 0 0 1.083.225Zm5.226 8.8a7.1 7.1 0 0 0 2.152-1.975 1.7 1.7 0 0 0 .313-.913.86.86 0 0 0-.36-.665 3 3 0 0 0-1.231-.509c-.221.295-.452.591-.68.882l-.015.017v.006l-.008.011-.015.017-.008.011v.006l-.013.017-.015.017-.013.017-.015.017v.006l-.008.011-.013.017-.008.011v.006l-.013.017-.013.017-.006.006-.006.006-.006.006-.006.006-.006.006-.006.006-.006.008-.006.006v.006l-.006.006-.031.011v.006l-.006.006-.011.013-.006.006-.006.006-.006.006-.006.006-.011.015-.006.006-.006.008-.006.006-.006.008-.006.006-.006.008-.006.006-.006.006-.006.008-.006.006-.006.008-.006.008-.006.006-.006.008-.006.008-.006.008-.006.006-.006.006-.006.006-.006.006-.028.029-.006.006.013.013-.007.011-.006.008-.006.008-.006.008-.006.008-.006.008-.006.008-.006.008-.006.008-.006.008-.006.008-.01.02-.006.008-.006.008-.006.008-.006.008-.006.008-.006.008-.008.008-.006.008a.9.9 0 0 1-.711.347.9.9 0 0 1-.713-.347c-.158-.2-.276-.353-.4-.507a26 26 0 0 1-1.8-2.476q-.33.477-.623.98-.437.751-.8 1.538a.34.34 0 0 1-.168.166 10.15 10.15 0 0 0 4.13 4.471 5.2 5.2 0 0 1 .589-.972 2.75 2.75 0 0 1 .866-.734Zm-1.086-6.558a1.121 1.121 0 1 0-.8-.328 1.12 1.12 0 0 0 .8.328m-1.8-3.185a2.76 2.76 0 0 1 3.608 0 3 3 0 0 1 .2.2 3.13 3.13 0 0 1 .76 1.811 3.25 3.25 0 0 1-.433 1.95 26 26 0 0 1-1.755 2.4c-.149.191-.3.379-.4.509a.3.3 0 0 1-.076.065.2.2 0 0 1-.1.019.2.2 0 0 1-.1-.019.2.2 0 0 1-.076-.065c-.1-.13-.248-.318-.4-.509a26 26 0 0 1-1.755-2.4 3.25 3.25 0 0 1-.435-1.96 3.1 3.1 0 0 1 .76-1.807 3 3 0 0 1 .199-.194Zm.524.785a1.8 1.8 0 1 0 1.277-.53 1.8 1.8 0 0 0-1.28.53Zm16.2-2.148a26 26 0 0 1-1.755 2.4c-.149.191-.3.379-.4.509a.2.2 0 0 1-.076.065.2.2 0 0 1-.1.019.2.2 0 0 1-.1-.019.24.24 0 0 1-.076-.065c-.1-.128-.248-.318-.4-.509a26 26 0 0 1-1.755-2.4 3.26 3.26 0 0 1-.433-1.955 3.1 3.1 0 0 1 .76-1.807q.095-.1.2-.2a2.76 2.76 0 0 1 3.608 0 3 3 0 0 1 .2.2 3.14 3.14 0 0 1 .76 1.811 3.23 3.23 0 0 1-.436 1.951Zm-.52-1.9a1.81 1.81 0 1 0-.53 1.277 1.8 1.8 0 0 0 .527-1.273Zm-1.81-1.119a1.121 1.121 0 1 0 .8.328 1.13 1.13 0 0 0-.8-.328"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed5b5a",
    d: "M822.784 438.241a1.537 1.537 0 0 0-1.537 1.538v6.8h7v-6.8a1.54 1.54 0 0 0-1.538-1.538zm2.043 10.032a.513.513 0 1 1-.513.513.513.513 0 0 1 .513-.513M824.653 431H806.54a1.54 1.54 0 0 0-1.539 1.539v10.338h14.521a.513.513 0 0 1 0 1.026H805v1.8a1.54 1.54 0 0 0 1.539 1.541h7.215v1.634h-2.051a.513.513 0 0 0 0 1.026h7.781a.513.513 0 0 0 0-1.026h-2.05v-1.634h3.1v-7.464a2.247 2.247 0 0 1 2.177-2.246.4.4 0 0 1 .07-.005h3.407v-4.989a1.54 1.54 0 0 0-1.539-1.539Zm-3.409 16.61v.754a1.54 1.54 0 0 0 1.54 1.538h3.921a1.54 1.54 0 0 0 1.538-1.538v-.754z"
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    fill: "#989898",
    fontFamily: "HonestJohns, Honest Johns",
    fontSize: 21,
    transform: "translate(846 445.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Q"))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    fill: "#989898"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M899.774 449.73h-.876c-.478.516-.917.959-1.263 1.3a1.27 1.27 0 0 1-.886.36 1.25 1.25 0 0 1-.886-.363 35 35 0 0 1-1.263-1.294h-.879c-1.222.218-2.011.568-2.011.962 0 .668 2.256 1.211 5.039 1.211s5.039-.54 5.039-1.211c.004-.397-.785-.747-2.014-.965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.352 450.53a.57.57 0 0 0 .806 0c1.291-1.26 5.233-5.312 5.233-7.918a5.636 5.636 0 0 0-11.272 0c-.003 2.605 3.942 6.661 5.233 7.918m-2.623-8.164a3.027 3.027 0 1 1 3.028 3.028 3.03 3.03 0 0 1-3.029-3.028ZM888.831 431.782a.412.412 0 1 0 .412.412.413.413 0 0 0-.412-.412M891.697 431.782a.412.412 0 1 0 .412.412.413.413 0 0 0-.412-.412M904.186 431.917h-7.416a.277.277 0 1 0 0 .554h7.417a.277.277 0 1 0 0-.554Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.388 430h-15.27a3.12 3.12 0 0 0-3.118 3.118v.928h21.5v-.928a3.11 3.11 0 0 0-3.112-3.118m-15.557 3.295a1.1 1.1 0 1 1 1.1-1.1 1.1 1.1 0 0 1-1.1 1.1m2.866 0a1.1 1.1 0 1 1 1.1-1.1 1.1 1.1 0 0 1-1.1 1.1m12.49-.135h-7.417a.968.968 0 0 1 0-1.935h7.417a.968.968 0 0 1 0 1.935M886 443.286a3.12 3.12 0 0 0 3.115 3.122h2.807a7.54 7.54 0 0 1-1.5-3.793 6.325 6.325 0 0 1 12.649 0 7.53 7.53 0 0 1-1.5 3.793h2.81a3.12 3.12 0 0 0 3.115-3.122v-8.552H886Zm17.931-7.347a.347.347 0 0 1 .346-.346h.893a1.05 1.05 0 0 1 0 2.1h-.55v.81a.346.346 0 0 1-.692 0v-2.565Zm-1.4 0a.346.346 0 1 1 .692 0v2.561a.346.346 0 1 1-.692 0Zm-14.968-.46h3.237a.346.346 0 1 1 0 .692h-3.236a.346.346 0 1 1 0-.692Zm0 1.156h2.029a.346.346 0 0 1 0 .692h-2.028a.346.346 0 0 1 0-.692Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.529 436.641a.36.36 0 0 0-.36-.36h-.55v.72h.55a.36.36 0 0 0 .36-.36"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M470 428h89a19 19 0 0 1 19 19 19 19 0 0 1-19 19h-89z"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(480.999 451)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "#4baf4b",
    rx: 5,
    transform: "translate(0 2)"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "ChickenSans-Regular, Chicken Sans",
    fontSize: 10,
    transform: "translate(14 11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1500")))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    fill: "#333",
    fontFamily: "ChickenSans-Bold, Chicken Sans",
    fontSize: 13,
    fontWeight: 700,
    transform: "translate(552.999 444)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15.97,
    y: 0
  }, "2000"))), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    fill: "#333",
    fontFamily: "ChickenSans-Regular, Chicken Sans",
    fontSize: 11,
    transform: "translate(506.999 443)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -26.185,
    y: 0
  }, "Responses"))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(531.999 450)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "ChickenSans-Regular, Chicken Sans",
    fontSize: 10,
    transform: "translate(22 11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.12,
    y: 0
  }, "500")), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "#e66564",
    rx: 5,
    transform: "translate(0 3)"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#ddd",
    transform: "translate(863 359)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    stroke: "none",
    rx: 11
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 10.5
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    fill: "#989898"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M871.944 365.747a2.337 2.337 0 1 0 2.251 2.335 2.235 2.235 0 0 0-2.251-2.335M868 374.765a2.9 2.9 0 0 0 .6 1.7c.341.4 6.551.369 6.68 0a2.92 2.92 0 0 0 .6-1.7 3.886 3.886 0 0 0-3.926-3.809h-.036a3.886 3.886 0 0 0-3.918 3.809M876.413 363a2.235 2.235 0 0 0-2.252 2.335 2.253 2.253 0 1 0 4.5 0 2.234 2.234 0 0 0-2.248-2.335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.431 368.208h-.036a4.1 4.1 0 0 0-1.624.351 2.86 2.86 0 0 1-1.308 2.047 4.49 4.49 0 0 1 2.965 3.4 10.3 10.3 0 0 0 3.325-.288 2.9 2.9 0 0 0 .6-1.7 3.886 3.886 0 0 0-3.922-3.81"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#989898",
    d: "M907.744 369.766a1.561 1.561 0 1 1-1.561-1.561 1.56 1.56 0 0 1 1.561 1.561m-1.562-8.091a1.561 1.561 0 1 0 1.561 1.561 1.56 1.56 0 0 0-1.561-1.561m0 13.058a1.561 1.561 0 1 0 1.561 1.561 1.56 1.56 0 0 0-1.561-1.561"
  })), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 15,
    fontWeight: 500,
    transform: "translate(479 371)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Burger King 12_07"))), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    fill: "#6c6c6c",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 15,
    transform: "translate(479 394)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0987POIUY"))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#989898",
    d: "M571.474 383a6.016 6.016 0 1 0 6.016 6.016 6.017 6.017 0 0 0-6.016-6.016m-.7 8.613v-2.754a.7.7 0 0 1 1.39 0v2.754a.7.7 0 1 1-1.39 0m.7-4.208a.836.836 0 1 1 .836-.836.836.836 0 0 1-.836.836"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    fill: "#fcf3dd",
    stroke: "#c99a30",
    transform: "translate(616 360)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 14,
    stroke: "none",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 13,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 1.5
  }))), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    fill: "#c99a30",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 10,
    fontWeight: 500,
    transform: "translate(620 371)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Paused")))));
};
export default SvgResQSlider1;